import React from "react";

const AppErrorFallback = () => {
  return (
    <div className="box has-text-centered mt-6" data-test="app-error-fallback">
      <h1 className="title is-3">Something went wrong</h1>
      <p className="subtitle is-5">Sorry, we couldn&apos;t load this page.</p>
      <button
        className="button is-primary mt-4"
        onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
};

export default AppErrorFallback;
